import React, {ReactNode} from 'react';
import {Link} from 'react-router-dom';
import style from './index.module.scss';


export interface IBreadcrumbProps {
    to?: string;
    title: ReactNode;
}

interface IBreadcrumbComponentProps {
    breadcrumb: IBreadcrumbProps;
    children: ReactNode;
}

interface IBreadcrumbContext {
    breadcrumbs: IBreadcrumbProps[];
}

export const BreadcrumbContext = React.createContext<IBreadcrumbContext>({
    breadcrumbs: []
});

export const Breadcrumb = ({breadcrumb, children}: IBreadcrumbComponentProps) => <BreadcrumbContext.Consumer>
    {value => <BreadcrumbContext.Provider value={{breadcrumbs: value.breadcrumbs.concat(breadcrumb)}}>
        {children}
    </BreadcrumbContext.Provider>}
</BreadcrumbContext.Consumer>;

export const Breadcrumbs = (props: React.HTMLAttributes<HTMLDivElement>) => <div className={style.breadcrumbs}>
    <BreadcrumbContext.Consumer children={({breadcrumbs}) => {
        let length = breadcrumbs.length;
        return <div {...props} className={[props.className, style.breadcrumbs].join(' ')}>{breadcrumbs.map((breadcrumb, index) =>
            <div key={`breadcrumb-${index}`} className={style.breadcrumb}>
                {breadcrumb.to
                    ? (
                        index < length - 1 ? <Link to={breadcrumb.to}>{breadcrumb.title}</Link> : breadcrumb.title
                    ) : breadcrumb.title
                }
            </div>)}</div>;
    }}
    />
</div>;
